import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LabelIcon from '@mui/icons-material/Label';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Alert,
  Button,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import Popup1099LTC from '@/components/ui/1099PopupLTC';
import ExtensionToInformationReturns from '@/components/ui/ExtensionToIR';
import PricingDetailsComp from '@/components/ui/PricingDetailsComp';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const Form1099LTC = () => {
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `<span style="color:#c1121f;font-size:18px; font-weight: 700;">Last Chance!</span> <span style="font-size:18px;">Form 1099 deadline is TODAY-</span><span style="color:#000; font-size:18px; font-weight: 600;">January 31, 2025</span><span style="font-size:18px;">! </span>`,
  //   SubHeading: 'File before it&apos;s too late!',
  //   CtaText: 'Submit Now',
  //   CtaSubHeading: ``,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099ltc`,
  //   isActive: true,
  // };
  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 3, 31));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 3, 31)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);
  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Day</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-file IRS Form 1099-LTC Online for 2025 | TaxZerone"
          description="File IRS Form 1099-LTC for 2025 online with TaxZerone. Report all long-term care insurance and accelerated death benefits accurately to meet IRS deadlines."
          keywords=""
          canonical="information-returns/efile-irs-form-1099-ltc/"
          jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="57448"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <Popup1099LTC />
      <InformationSubMenu />
      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
        component="section"
      >
        <Box
          sx={{
            background:
              'linear-gradient(90deg,rgba(94, 16, 110, 1) 35%, rgba(22, 32, 87, 1) 100%)',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component="div"
              variant="body1"
              sx={{
                textAlign: { xs: 'left', sm: 'left' },
                fontSize: { xs: 15, sm: 17, md: 18, lg: '1.22rem' },
                color: '#ccc',
                lineHeight: 1.3,
              }}
            >
              <strong>📢 Deadline Has Passed! </strong> E-File Your 2025{' '}
              <b style={{ fontWeight: 600, color: '#fec89a' }}>Form 1099-LTC</b>{' '}
              Today to Stay IRS-Compliant and Avoid Penalties.
            </Typography>
            <Box>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  Feb 02, 2026
                </span>
                ):
              </Typography> */}
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>

            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099ltc`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#213e99',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-File Form 1099-LTC
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>

      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                File{' '}
                <span className="highlight-container">
                  <span className="highlight"> Form 1099-LTC</span>
                </span>{' '}
                for Tax Year 2025 with Ease
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Report long-term care benefits and other related payments with
                TaxZerone’s fast, secure, and hassle-free e-filing solution
                <Hidden mdUp>
                  <br />
                </Hidden>{' '}
                for Form 1099-LTC.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099ltc`}
                  >
                    File Form{' '}
                    <Box
                      component="span"
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      1099-LTC
                    </Box>
                  </Button>
                  {/*  */}
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/ltc-landing-img.webp" />
                <source srcSet="/assets/images/ltc-landing-img.png" />
                <img
                  src="/assets/images/ltc-landing-img.png"
                  alt="File Form 1099-LTC for Tax Year 2025 with Ease"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/ltc-landing-img-sm.webp" />
                <source srcSet="/assets/images/ltc-landing-img-sm.png" />
                <img
                  src="/assets/images/ltc-landing-img-sm.png"
                  alt="File Form 1099-LTC for Tax Year 2025 with Ease"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                Affordable Pricing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                Starting at just{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $2.49
                </Box>
                , with prices as low as{' '}
                <Box
                  component="strong"
                  sx={{
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $0.59
                </Box>{' '}
                per form for bulk filings.
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 180, md: 200 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href="/pricing/#informationreturns"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
              <Typography
                variant="body2"
                sx={{ mt: 0, mb: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                For your return volume
              </Typography>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Paper
                variant="outlined"
                sx={{
                  p: { xs: 2, sm: 4, md: 6 },
                  borderRadius: 10,
                  backgroundColor: '#f5f6f7',
                  maxWidth: 780,
                  mx: 'auto',
                  boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 4,
                    textAlign: 'center',
                  }}
                >
                  Filing Requirements for Form 1099-LTC
                </Typography>

                <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
                  Let&apos;s simplify your 1099-LTC filing! Here&apos;s what
                  you’ll need:
                </Typography>
                <Box
                  sx={{
                    justifyContent: 'center',
                    px: { xs: 0, sm: 2, md: 14 },
                  }}
                >
                  <List>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b> Payer Information:</b> Payer’s Name, TIN, and
                        Address
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b> Policyholder Information:</b> policyholder Name,
                        TIN, and Address
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b> Payment Information:</b> Payments for long-term care
                        benefits and Accelerated death benefits
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                3 Simple Steps to Complete Your Form 1099-LTC E-filing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing your Form 1099-LTC with TaxZerone is quick, easy, and
                secure. Here’s how you can do it in just three steps:
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/ltc-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/ltc-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/ltc-steps-img.png"
                  alt="3 Simple Steps to Complete Your Form 1099-LTC E-filing"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Enter Information for Form 1099-LTC"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Enter Information for Form 1099-LTC
                    </Typography>
                    <Typography variant="body1">
                      Simply fill in your Business and Individual details
                      (EIN/SSN), Policyholder and Insured information (name,
                      address, TIN), and the long-term care benefits paid.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Review & Transmit"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Review & Transmit
                    </Typography>
                    <Typography variant="body1">
                      Ensure accuracy with TaxZerone’s IRS validations, then
                      securely e-file your Form 1099-LTC with the IRS.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Send Policyholder Copy"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Send Policyholder Copy
                    </Typography>
                    <Typography variant="body1">
                      Securely deliver the policyholder and Insured copy via
                      ZeroneVault, ensuring safe sharing, or choose postal mail
                      for a physical copy.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>

              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099ltc`}
                >
                  File Form 1099-LTC
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Choose TaxZerone for Form 1099-LTC E-filing?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone is the trusted e-filing solution for businesses of all
                sizes. Here’s why:
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-rule-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-rule-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-rule-icon.png"
                      alt="IRS Form Validations"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS Form Validations
                </Typography>
                <Typography variant="body1">
                  TaxZerone performs automatic IRS form validations to ensure
                  your Form 1099-LTC submissions are accurate and compliant. Our
                  system checks for errors or missing information, reducing the
                  risk of rejections and penalties from the IRS.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Supports Bulk Upload"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Supports Bulk Upload
                </Typography>
                <Typography variant="body1">
                  If you have multiple 1099-LTC forms to file, TaxZerone offers
                  a bulk upload option. Upload and file multiple forms in one
                  go, saving you time and effort. Whether you have a few
                  Policyholders or hundreds, we’ve got you covered.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Share Policyholder Copies"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Share Policyholder Copies
                </Typography>
                <Typography variant="body1">
                  After filing your Form 1099-LTC, easily share a copy with the
                  Policyholder and Insured. With ZeroneVault, enjoy secure
                  electronic delivery—no need for printing or mailing physical
                  copies. Alternatively, you can opt for postal mail to ensure
                  timely delivery.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Best Price in the Industry"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Best Price in the Industry
                </Typography>
                <Typography variant="body1">
                  We offer the best prices based on your filing volume.
                  TaxZerone’s e-filing services are designed to save you both
                  time and money. Whether you’re filing one form or many, we
                  offer affordable pricing without compromising on quality.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/form-based-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/form-based-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/form-based-icon.png"
                      alt="Form-based Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Form-based Filing
                </Typography>
                <Typography variant="body1">
                  Filing your Form 1099-LTC is easy with TaxZerone’s form-based
                  interface. Simply fill out the necessary fields directly in
                  our platform, and we’ll handle the rest.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt=" Guided filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided filing
                </Typography>
                <Typography variant="body1">
                  Not sure about a particular field or requirement? No problem!
                  Our guided filing process provides clear instructions, helpful
                  prompts, and real-time assistance to make sure you complete
                  your Form 1099-LTC filing with confidence.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pb: 15,
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 0,
                  textAlign: 'center',
                }}
              >
                Important Deadlines for Filing Form 1099-LTC
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            m={2}
            mt={2}
            py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/recipient-copies-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/recipient-copies-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/recipient-copies-icon.png"
                      alt="Send Policyholder copies"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Send Policyholder copies
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span style={{ color: '#cc2936', fontWeight: 600 }}>
                    February 2 , 2026
                  </span>{' '}
                  <br />
                  Deliver Policyholder copies securely via ZeroneVault or opt
                  for postal mail.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="File with the IRS (e-file)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  File with the IRS (e-file)
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span style={{ color: '#cc2936', fontWeight: 600 }}>
                    March 31, 2026
                  </span>{' '}
                  <br />
                  Submit your Form 1099-LTC electronically.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/paper-file-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/paper-file-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/paper-file-icon.png"
                      alt="File with the IRS (paper)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  File with the IRS (paper)
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span style={{ color: '#cc2936', fontWeight: 600 }}>
                    March 2, 2026
                  </span>{' '}
                  <br />
                  Mail your Form 1099-LTC if filing on paper.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={12}>
              <Box sx={{ mt: 3, textAlign: 'center' }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    mb: 1,
                    fontWeight: 600,
                  }}
                >
                  Save Time and Stress with TaxZerone
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  File your 1099-LTC forms on time, effortlessly, and securely.
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099ltc`}
                >
                  Start Filing Now!
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box component="section" sx={{ px: { xs: 4, sm: 3, lg: 0 } }}>
        <ExtensionToInformationReturns
          formName="form 1099 ltc"
          formRef="form1099ltc"
        />
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5, mt: 5 }}>
          <PricingDetailsComp formName="Form 1099-LTC" colorCode="#4269e2" />
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} sx={{ textAlign: 'center' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                State Filing Not Required for Form 1099-LTC
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                There are no state-specific tax filing requirements for Form
                1099-LTC. TaxZerone ensures your federal filing is{' '}
                <Hidden mdDown>
                  <br />
                </Hidden>
                complete and compliant, so you don’t need to worry about any
                additional state-level reporting.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Schedule Filing: Plan Ahead and Stay On Track
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center' }}>
                Want to ensure your filings are submitted on time without the
                you can stress? With Schedule Filing,{' '}
                <Hidden smDown>
                  <br />
                </Hidden>
                your Form 1099-LTC filings in advance, and we’ll take care of
                the submission when the time comes.
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            mt={2}
            py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
            justifyContent="center"
            sx={{ position: 'relative' }}
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                elevation={0}
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: 'transparent',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                    zIndex: 2,
                    position: 'relative',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/due-date-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/due-date-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/due-date-icon.png"
                      alt="Choose Your Filing Date"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Choose Your Filing Date
                </Typography>
                <Typography variant="body1">
                  Set your preferred filing date, and we’ll ensure your forms
                  are submitted to the IRS promptly and accurately.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                elevation={0}
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: 'transparent',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                    zIndex: 2,
                    position: 'relative',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/review-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/review-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/review-icon.png"
                      alt="Ensure Accuracy"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Ensure Accuracy
                </Typography>
                <Typography variant="body1">
                  Policyholders can review their 1099-LTC forms before
                  submission, allowing them to identify and correct any errors
                  in advance.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                elevation={0}
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: 'transparent',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                    zIndex: 2,
                    position: 'relative',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/smart-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/smart-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/smart-icon.png"
                      alt="Avoid the Need for IRS Correction Forms"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Avoid the Need for IRS Correction Forms
                </Typography>
                <Typography variant="body1">
                  Scheduling your filing provides an opportunity to validate all
                  details beforehand, reducing errors and eliminating the hassle
                  of filing IRS correction forms later.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid
                size={12}
                sx={{
                  position: 'absolute',
                  zIndex: 1,
                  top: '75px',
                  right: 35,
                  opacity: 0.5,
                }}
              >
                <img
                  src="/assets/images/dot-shape.svg"
                  alt=""
                  width="100%"
                  height="133"
                  style={{ width: '100%', maxWidth: 1100, height: 133 }}
                />
              </Grid>
            </Hidden>
            <Grid size={12}>
              <Box sx={{ mt: 3, textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 0,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099ltc`}
                >
                  Schedule 1099-LTC Now!
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Deliver Policyholder Copies with Ease
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center' }}>
                TaxZerone simplifies the process of sharing Form 1099-LTC copies
                with your Policyholders securely and on time.{' '}
                <Hidden smDown>
                  <br />
                </Hidden>
                Select the method that suits your needs best:
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            mt={2}
            // py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
            justifyContent="center"
            sx={{ position: 'relative', mb: 4 }}
          >
            <Grid size={{ xs: 12, sm: 6 }}>
              <Paper
                elevation={0}
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 5px 0px',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: 'transparent',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'left',
                    alignItems: 'left',
                    m: 0,
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/vault-logo.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/vault-logo.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/vault-logo.png"
                      alt="Secure Delivery via ZeroneVault"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: '20px !important',
                      fontWeight: 600,
                      textAlign: 'left',
                      mt: 1,
                    }}
                  >
                    Secure Delivery via ZeroneVault{' '}
                  </Typography>
                  <Typography variant="body1" sx={{ mt: 2 }}>
                    Send Policyholder and Insured copies electronically using
                    ZeroneVault, a secure and intuitive platform.
                  </Typography>
                  <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                    <li>
                      Policyholders can access their forms instantly without
                      needing to print or mail.
                    </li>
                    <li>
                      ZeroneVault prioritizes data security, ensuring the safe
                      handling of sensitive tax information.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Paper
                elevation={0}
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 5px 0px',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'left',
                    alignItems: 'left',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Traditional Postal Mailing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box sx={{}}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: '20px !important',
                      fontWeight: 600,
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    Traditional Postal Mailing{' '}
                  </Typography>
                  <Typography variant="body1">
                    Prefer physical copies? TaxZerone offers reliable postal
                    mailing services.
                  </Typography>
                  <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 2 }}>
                    <li>
                      Policyholder and Insured copies are dispatched promptly,
                      helping you meet IRS deadlines with ease.
                    </li>
                    <li>
                      Save time and reduce stress by allowing TaxZerone to
                      manage the mailing process for you.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Get Started with TaxZerone Today
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Filing Form 1099-LTC online has never been easier. With TaxZerone, you
          can:
        </Typography>
        <Box
          sx={{
            textAlign: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <Stack
            spacing={1}
            direction={{ xs: 'column', sm: 'row' }}
            sx={{
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              m: 0,
            }}
          >
            <Box>
              <List>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    File quickly and accurately.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Stay compliant with IRS requirements.
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
            <Box>
              <List>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Save time with bulk upload.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    File at the best price in the industry.
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
          </Stack>
        </Box>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 400,
            color: '#f3f3f3',

            lineHeight: 1.5,
          }}
        >
          Start your e-filing process today and complete your Form 1099-LTC in
          just 3 simple steps!
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099ltc`}
          >
            File Form 1099-LTC Now!
          </Button>
        </Box>
      </Box>
      <Container
        maxWidth="lg"
        component="section"
        aria-labelledby="f1099-ltc-faq"
      >
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              id="f1099-ltc-faq"
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 3 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is Form 1099-LTC?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="p" sx={{ mt: 1 }}>
                      Form 1099-LTC is an IRS form used to report long-term care
                      insurance benefits or payments made under accelerated
                      death benefits of a life insurance policy. Insurance
                      companies, government agencies, and viatical settlement
                      providers file this form to provide information about the
                      disbursement of benefits to policyholders or their
                      representatives.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Who Needs to File Form 1099-LTC?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="p" sx={{ mt: 1 }}>
                      The following entities are required to file Form 1099-LTC:
                    </Typography>
                    <ul>
                      <li style={{ marginBottom: 8 }}>
                        <b> Insurance Companies:</b> Reporting payments under
                        long-term care insurance contracts.
                      </li>
                      <li style={{ marginBottom: 8 }}>
                        <b> Government Agencies:</b> Reporting benefits paid
                        under a qualified long-term care insurance program.
                      </li>
                      <li style={{ marginBottom: 8 }}>
                        <b> Payers:</b> Reporting accelerated death benefits
                        paid under life insurance policies.
                      </li>
                    </ul>
                    <Typography component="div" sx={{ mt: 0 }}>
                      If you make these types of payments, you must file Form
                      1099-LTC to the IRS and provide a copy to the policyholder
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  When is the Deadline to File Form 1099-LTC?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="p" sx={{ mt: 1 }}>
                      The deadlines for filing Form 1099-LTC are as follows:
                    </Typography>
                    <ul>
                      <li style={{ marginBottom: 8 }}>
                        <b>Policyholder Copy:</b> Must be sent by{' '}
                        <b>February 2, 2026</b>, for the 2025 tax year.
                      </li>
                      <li style={{ marginBottom: 8 }}>
                        <b> IRS Filing (Paper):</b> Must be submitted by{' '}
                        <b>March 2, 2026</b>.
                      </li>
                      <li style={{ marginBottom: 8 }}>
                        <b> IRS Filing (E-file):</b> Must be submitted by{' '}
                        <b>March 31, 2026</b>.
                      </li>
                    </ul>
                    <Alert
                      severity="warning"
                      icon={false}
                      sx={{ mb: 0, mt: 0 }}
                    >
                      If the due date falls on a weekend or holiday, the
                      deadline is extended to the next business day.
                    </Alert>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What are the Penalties for Late Filing of Form 1099-LTC?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="p" sx={{ mt: 1 }}>
                      The penalties for late filing of Form 1099-LTC depend on
                      how late the filing is:
                    </Typography>
                    <ol>
                      <li style={{ marginBottom: 8 }}>
                        <b>Filed within 30 days of the deadline:</b>
                      </li>
                      <ul style={{ listStyleType: 'disc' }}>
                        {' '}
                        <li style={{ marginBottom: 8 }}>$60 per form</li>
                        <li style={{ marginBottom: 8 }}>
                          Maximum penalty per year: $239,000 for small
                          businesses, $683,000 for large businesses.
                        </li>
                      </ul>
                      <li style={{ marginBottom: 8 }}>
                        <b>
                          Filed more than 30 days after the deadline but before
                          August 1, 2025:
                        </b>
                      </li>
                      <ul style={{ listStyleType: 'disc' }}>
                        {' '}
                        <li style={{ marginBottom: 8 }}>$130 per form</li>
                        <li style={{ marginBottom: 8 }}>
                          Maximum penalty per year: $683,000 for small
                          businesses, $2,049,000 for large businesses.
                        </li>
                      </ul>
                      <li style={{ marginBottom: 8 }}>
                        <b>Filed after August 1, 2025, or not filed at all:</b>
                      </li>
                      <ul style={{ listStyleType: 'disc' }}>
                        {' '}
                        <li style={{ marginBottom: 8 }}>$340 per form</li>
                        <li style={{ marginBottom: 8 }}>
                          Maximum penalty per year: $1,366,000 for small
                          businesses, $4,098,500 for large businesses.
                        </li>
                      </ul>
                    </ol>
                    <Typography variant="body1">
                      Additionally, penalties may apply for incorrect or
                      incomplete forms or for failing to provide Policyholder
                      copies on time. To avoid penalties, ensure timely and
                      accurate filing of Form 1099-LTC.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form1099LTC;
